import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/site-data';

const featuredImages: Record<string, string> = {
  'article-cover-01': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20desk%20scene%20with%20warm%20golden%20ambient%20lighting%2C%20soft%20creamy%20textured%20paper%20background%2C%20professional%20writing%20atmosphere%2C%20delicate%20details%2C%20clean%20and%20sophisticated%20composition%2C%20warm%20neutral%20tones%20with%20subtle%20amber%20highlights&width=800&height=450&seq=article-cover-01&orientation=landscape',
  'article-cover-02': 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20workspace%20with%20documents%20neatly%20arranged%20on%20a%20warm%20wooden%20desk%2C%20soft%20natural%20light%20streaming%20from%20the%20side%2C%20minimalist%20office%20decor%2C%20warm%20beige%20and%20cream%20color%20palette%2C%20sophisticated%20and%20professional%20atmosphere&width=800&height=450&seq=article-cover-02&orientation=landscape',
  'article-cover-03': 'https://readdy.ai/api/search-image?query=Official%20document%20processing%20scene%20with%20organized%20paperwork%20and%20a%20fountain%20pen%20on%20a%20warm%20toned%20surface%2C%20soft%20diffused%20lighting%2C%20elegant%20and%20official%20ambience%2C%20creamy%20background%20textures%2C%20professional%20government%20document%20style&width=800&height=450&seq=article-cover-03&orientation=landscape',
  'article-cover-04': 'https://readdy.ai/api/search-image?query=Neatly%20stacked%20forms%20and%20documents%20on%20a%20light%20wooden%20desk%20with%20a%20coffee%20cup%2C%20warm%20morning%20light%2C%20organized%20and%20calm%20workspace%2C%20beige%20and%20cream%20tones%2C%20professional%20atmosphere&width=800&height=450&seq=article-cover-04&orientation=landscape',
  'article-cover-05': 'https://readdy.ai/api/search-image?query=An%20important%20looking%20document%20with%20a%20magnifying%20glass%20highlighting%20details%2C%20warm%20amber%20lighting%2C%20symbolic%20of%20caution%20and%20attention%2C%20elegant%20minimal%20composition%2C%20creamy%20background%20texture&width=800&height=450&seq=article-cover-05&orientation=landscape',
  'article-cover-06': 'https://readdy.ai/api/search-image?query=Two%20contrasting%20documents%20side%20by%20side%20on%20a%20warm%20surface%2C%20one%20marked%20with%20a%20checkmark%20and%20one%20with%20a%20cross%20symbol%2C%20soft%20natural%20lighting%2C%20truth%20vs%20myth%20concept%2C%20cream%20and%20gold%20color%20palette&width=800&height=450&seq=article-cover-06&orientation=landscape',
  'article-cover-07': 'https://readdy.ai/api/search-image?query=Emergency%20document%20replacement%20concept%20with%20urgent%20red%20stamp%20on%20a%20document%2C%20warm%20lighting%2C%20professional%20office%20background%20with%20soft%20bokeh%2C%20minimalist%20composition&width=800&height=450&seq=article-cover-07&orientation=landscape',
  'article-cover-08': 'https://readdy.ai/api/search-image?query=Calendar%20with%20highlighted%20expiration%20date%20next%20to%20an%20official%20looking%20document%2C%20warm%20golden%20lighting%2C%20professional%20desk%20setup%2C%20cream%20and%20beige%20tones&width=800&height=450&seq=article-cover-08&orientation=landscape',
  'article-cover-09': 'https://readdy.ai/api/search-image?query=Law%20books%20and%20legal%20documents%20neatly%20arranged%20on%20a%20warm%20wooden%20desk%2C%20scales%20of%20justice%20in%20the%20background%2C%20soft%20ambient%20lighting%2C%20elegant%20and%20authoritative%20composition&width=800&height=450&seq=article-cover-09&orientation=landscape',
  'article-cover-10': 'https://readdy.ai/api/search-image?query=Modern%20digital%20tablet%20displaying%20policy%20updates%20alongside%20a%20physical%20document%2C%20warm%20contemporary%20workspace%2C%20soft%20natural%20light%2C%20transition%20from%20paper%20to%20digital%20concept&width=800&height=450&seq=article-cover-10&orientation=landscape',
  'article-cover-11': 'https://readdy.ai/api/search-image?query=Laptop%20displaying%20online%20application%20form%20on%20a%20clean%20desk%20with%20warm%20coffee%20tones%2C%20modern%20digital%20lifestyle%2C%20soft%20natural%20lighting%2C%20convenient%20online%20service%20concept&width=800&height=450&seq=article-cover-11&orientation=landscape',
  'article-cover-12': 'https://readdy.ai/api/search-image?query=Document%20preservation%20concept%20with%20protective%20folder%20and%20archival%20materials%20on%20a%20warm%20surface%2C%20soft%20daylight%2C%20organized%20and%20careful%20storage%20idea%2C%20cream%20and%20beige%20color%20palette&width=800&height=450&seq=article-cover-12&orientation=landscape',
};

export default function FeaturedArticles() {
  const featured = allArticles.filter((a) => a.isFeatured).slice(0, 4);
  const latest = allArticles.filter((a) => !a.isFeatured).slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-4">
              精选内容
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              推荐阅读
            </h2>
          </div>
          <Link
            to="/category/dingyi-yongtu"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mb-14">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={featuredImages[article.imageSeq] || featuredImages['article-cover-01']}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2.5 flex-wrap">
                  <span className="px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100 rounded whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <span className="text-xs text-foreground-400 mt-3">{article.publishDate}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-4">
              最新发布
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新文章
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <span className="px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100 rounded self-start mb-3 whitespace-nowrap">
                  {article.categoryName}
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 flex-1">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.readTime}</span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}